<template>
  <div id="app">
    <div class="login_block">
      <van-form class="form_login" @submit="onSubmit" :show-error-message="false">
        <!-- 学生姓名 -->
        <van-field
          v-model="studentName"
          name="studentName"
          input-align="right"
          label="学生姓名"
          placeholder="请输入学生姓名"
          :rules="[{ required: true, message: '请输入学生姓名' }]"
        />
        <!-- 学生身份证号 -->
        <van-field
          :value="studentNumber"
          name="idNumber"
          input-align="right"
          label="学生身份证号"
          :maxlength="18"
          placeholder="请输入学生身份证号"
          @touchstart.native.stop="idNumberShow = true"
          :rules="[{ required: true, message: '请输入学生身份证号' }]"
        />
        <van-number-keyboard
          v-model="studentNumber"
          :show="idNumberShow"
          extra-key="X"
          close-button-text="完成"
          @blur="idNumberShow = false"
        />
        <div style="margin:30px 16px">
          <van-button type="info" color="linear-gradient(to bottom, #84C3FF, #43A5FF)" round native-type="submit" block
            >查询</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      idNumberShow: false,
      studentName: "",
      studentNumber: "",
    };
  },
  created() {},
  mounted() {},
  methods: {
    onSubmit(val) {
      console.log(val);
    },
  },
};
</script>
<style scoped>
#app {
  box-sizing: border-box;
  padding-top: 44.8vh;
  width: 100%;
  height: 100vh;
  background: url("../assets/img/lqbg.png") no-repeat;
  background-size: contain;
}
.login_block {
  box-sizing: border-box;
  width: 8.7rem;
  height: 7rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.3rem;
  margin: 0 auto;
  padding: 0.5rem 0.4rem;
}
.van-cell {
    padding: 0.6rem 0.6rem;
}
.form_login {
}
</style>


// WEBPACK FOOTER //
// src/view/admission.vue